import { render, staticRenderFns } from "./DeleteDashboardModal.vue?vue&type=template&id=36257272&scoped=true&"
import script from "./DeleteDashboardModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteDashboardModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteDashboardModal.vue?vue&type=style&index=0&id=36257272&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36257272",
  null
  
)

export default component.exports